const checkStatus = response => {
	if (response.status >= 200 && response.status < 300) {
		return response;
	} else {
		const error = new Error(response.statusText);
		error.name = String(response.status);
		throw error;
	}
};

const optionallyParseJSON = response =>
	response.text().then(text => (text ? JSON.parse(text) : undefined));

const getStandardHeaders = (contentType = 'application/json') => {
	const headers = new Headers();
	headers.append('Accept', 'application/json');
	if (contentType !== null) headers.append('Content-Type', contentType);
	return headers;
};

const getNonCachedHeaders = (contentType = 'application/json') => {
	const headers = new Headers();
	headers.append('Accept', 'application/json');
	headers.append('pragma', 'no-cache');
	headers.append('cache-control', 'no-cache');
	if (contentType !== null) headers.append('Content-Type', contentType);
	return headers;
};

export const fetchJson = path =>
	fetch(path, {headers: getStandardHeaders(), credentials: 'same-origin'})
		.then(checkStatus)
		.then(optionallyParseJSON);

export const fetchNonCachedJson = path =>
	fetch(path, {headers: getNonCachedHeaders(), credentials: 'same-origin'})
		.then(checkStatus)
		.then(optionallyParseJSON);

export const putJson = (path, body) =>
	fetch(path, {
		credentials: 'same-origin',
		headers: getStandardHeaders(),
		method: 'PUT',
		body: JSON.stringify(body)
	})
		.then(checkStatus)
		.then(optionallyParseJSON);

export const putJsonWithResponse = (path, body) => putJson(path, body);

export const postJson = (path, body) =>
	fetch(path, {
		credentials: 'same-origin',
		headers: getStandardHeaders(),
		method: 'POST',
		body: JSON.stringify(body)
	})
		.then(checkStatus)
		.then(optionallyParseJSON);

export const deleteJson = (path, body) =>
	fetch(path, {
		credentials: 'same-origin',
		headers: getStandardHeaders(),
		method: 'DELETE'
	})
		.then(checkStatus)
		.then(optionallyParseJSON);

export const postForm = (path, body) => {
	const formData = new FormData();
	Object.keys(body).forEach(key => formData.append(key, body[key]));
	return fetch(path, {
		credentials: 'same-origin',
		headers: getStandardHeaders(null),
		method: 'POST',
		body: formData
	}).then(checkStatus);
};

export const postFile = (url, body, updateProgress) =>
	new Promise((resolve, reject) => {
		const req = new XMLHttpRequest();
		req.upload.addEventListener('progress', evt => {
			if (evt.lengthComputable) {
				updateProgress(evt.loaded / evt.total);
			} else {
				// Unable to compute progress information since the total size is unknown
			}
		});
		req.upload.addEventListener('error', evt => reject());
		req.upload.addEventListener('abort', evt => reject());

		req.open('POST', url, true);
		req.onreadystatechange = evt => {
			if (req.readyState === 4) {
				//run any callback here
				try {
					resolve(checkStatus(req));
				} catch (e) {
					reject(e);
				}
			}
		};
		const formData = new FormData();
		Object.keys(body).forEach(key => formData.append(key, body[key]));
		req.send(formData);
	});

export default fetchJson;



// WEBPACK FOOTER //
// ./src/fetchJson.js